module.exports = __webpack_public_path__ + "img/631.problem_sink.2c4fd053.svg";